<template>
	<div id='handitemedit' >
		<div class="tabelMoreFzView main-mybody" style="height: 17rem;overflow-y: auto;padding:0px;" :style="{height: form.aduit ?'17rem':'21rem' }">
			<div class="tabelMoreFzViewIn" style="padding:0.5rem 1.5rem 0.5rem">
				<div class="look_g" style="padding:0.55rem 0">
					<div></div>客戶資料
				</div>
				<a-row>
					<a-col :span='inds==moreFzOption.length-4|| inds==moreFzOption.length-3  ?24:12' v-for="(item,inds) in moreFzOption" :key="inds + '1136'">
						<div class="tabelMoreFzViewInList" :style="{left: inds%2 == 0  ?'0%':'14%',position: 'relative'}" v-if="!(inds+3==moreFzOption.length) && !(inds+4==moreFzOption.length)">
							<div class="left"   style="text-align: right;" :style="{width:inds+4==moreFzOption.length|| inds+3==moreFzOption.length ?'12%' :'24%'}" :class="inds+4==moreFzOption.length|| inds+3==moreFzOption.length ? 'bjb_win1':'bjb_win2'">{{item.text}}：</div>
							<div class="center" style="word-wrap:break-word" :style="{marginLeft:inds+4==moreFzOption.length|| inds+3==moreFzOption.length ?'' :'',width:inds+4==moreFzOption.length|| inds+3==moreFzOption.length ?'91%':''}">{{item.value}}</div>
						</div>
						<div v-else>
							<div style="display:flex;     padding: 0.5rem 0;">
								<div style="width: 12%;text-align: right;font-size: 0.835rem;flex-shrink: 0;" class="bjb_win1">{{item.text}}：</div>
								<div style="font-size: 0.835rem;border: 1px solid #d9d9d9;width: 100%;
								border-radius: 4px;
								padding: 4px 11px;
								margin-left: 1%;
								height: 2.75rem;
								display: flex;
								">{{item.value}}</div>
							</div>
						</div>
					</a-col>
				</a-row>
			</div>
			<!-- 签名查看 -->
			<div class="qianming_class" v-if="$store.state.rolesdata.indexOf('khadmin3') >= 0">
				<div style="padding:0.9rem 1.5rem 0.5rem">
					<div class="look_g1" style="padding:0.55rem 0">
						<div class="vertical_class"></div>簽署樣式
						<img :src="ck" alt="" style="cursor: pointer;margin-bottom: 2px;margin-left: 5px;" @click="imgOpenClick(params.signature)">
						<!-- <el-image style="width: 20px; height: 22px;position: relative;top: 4px;margin-left: 10px;" :src="ck" :preview-src-list="[params.signature]"></el-image> -->
					</div>
				</div>
			</div>
			<!-- 開戶方式 -->
			<div class="yongjin_class" v-if="$store.state.rolesdata.indexOf('khadmin3') >= 0">
				<div style="padding:0.9rem 1.5rem">
					<div class="look_g" style="padding:0.55rem 0">
						<div></div>開戶方式
					</div>
					<div style="display: flex;align-items: center;width: 48.5%;">
						<div style="flex-shrink: 0;color: #000;font-size: 0.835rem;"  class="bjb_width">開戶方式：</div>
						<a-select v-model="params.khType" placeholder="請選擇開戶方式" style="width: 100%;" disabled>
							<a-select-option value="網上開戶">網上開戶</a-select-option>
							<!-- <a-select-option value="1">預約開戶</a-select-option> -->
							<a-select-option value="支票開戶">支票開戶</a-select-option>
						</a-select>
					</div>
				</div>
			</div>
			<!-- 香港佣金 -->
			<div class="yongjin_class">
				<div style="padding:0.9rem 1.5rem 0.5rem">
					<div class="look_g" style="padding:0.55rem 0">
						<div></div>佣金資料
					</div>
					<div class="text" style="position: relative; left: -14px;">香港證券交易</div>
					<div style="display:flex;">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">非電子交易：</div>
							<a-input v-model="params.non_hkd_ratio" suffix="%" disabled></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">電子交易：</div>
							<a-input v-model="params.hkd_ratio" suffix="%" disabled></a-input>
						</div>
					</div>
					<div class="text" style="position: relative; left: -14px;">最低交易收費</div>
					<div style="display:flex;">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">非電子交易：</div>
							<a-input v-model="params.non_hkd_min" suffix="HKD" disabled></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">電子交易：</div>
							<a-input v-model="params.hkd_min" suffix="HKD" disabled></a-input>
						</div>
					</div>
				</div>
			</div>
			<!-- 美國佣金 -->
			<div class="yongjin_class">
				<div style="padding:0.55rem 1.5rem 0">
					<div class="text" style="padding-bottom: 0;position: relative; left: -14px;">美國證券交易</div>
					<div style="display:flex;">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">非電子交易：</div>
							<a-input v-model="params.non_us_ratio" suffix="每股/USD" disabled></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">電子交易：</div>
							<a-input v-model="params.us_ratio" suffix="每股/USD" disabled ></a-input>
						</div>
					</div>
					<div class="text" style="position: relative; left: -14px;">最低交易收費</div>
					<div style="display:flex;padding-bottom:0.7rem">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">非電子交易：</div>
							<a-input v-model="params.non_us_min" suffix="USD" disabled></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_text1">電子交易：</div>
							<a-input v-model="params.us_min" suffix="USD" disabled></a-input>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class='warp_daochu' v-if='form.aduit'>
			<div v-if="$store.state.rolesdata.indexOf('khadmin4') >= 0">
				<a-radio-group v-model="type_of_data" style="width: 4rem;padding-left: 0.5rem;">
					<a-radio style="margin-top:3px;font-size:0.8rem;color:#000" value="0">客戶資料</a-radio>
					<a-radio style="margin-top:5px;font-size:0.8rem;color:#000" value="1">佣金資料</a-radio>
				</a-radio-group>
			</div>
			<div style="padding-left: .5rem;" :style='{width:!form.shKhadmin1Bol? "20rem":"34.5rem"}' v-if="$store.state.rolesdata.indexOf('khadmin4') >= 0">
				    <a-textarea v-model='form.remark' placeholder=" " allow-clear  style='width: 100%;'/>
			</div> 
			<div style="padding-left: .5rem;" :style='{width:!form.shKhadmin1Bol? "24rem":"27rem"}' v-else>
				    <a-textarea v-model='form.remark' placeholder=" " allow-clear  style='width: 100%;'/>
			</div> 
			<div style="padding: .35rem 0;" v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0" class="qx_bkb">
				<!-- <button class='btn1' v-if='!form.shKhadmin1Bol' @click='shUnTgEvent(record,"1")' style="background-color: #ed4849;">審核拒絕</button> -->
				<button class='btn1'  @click='shTgEvent(record,"2")' style="background-color: #ed4849;">取消開戶</button>
				<button class='btn1 btnx' @click='shTgEvent(record , "0")' >{{form.shKhadmin1Bol ? '已處理' :'審核通過'}}</button>
				<!-- f48d24 -->
			</div>
			<div style="padding: .35rem 0;" v-else  class="qx_bkb">
				<button class='btn1'  @click='shUnTgEvent(record,"1")' style="background-color: #ed4849;">審核拒絕</button>
				<button class='btn1 btnx' @click='shTgEvent(record , "0")' style="margin-left: 60px;">審核通過</button>
			</div>
		</div>
		<div class="back_view" v-if="openFlag">
			<div class="back_close" @click="openFlag = false">
				<a-icon type="close" style="font-size:1rem"></a-icon>
			</div>
			<div class="back_div">
				<div class="back_div_img">
					<img :src="params.signature" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import ck from '../../../image/icon/sign_img.png';
	export default {
		props: ['record','forms','picList'],
		components: {ck},
		data() {
			return {
				openFlag:false,
				ck:ck,
				type_of_data:'',
				params:{},
				moreFzOption:[],
				form:{
					remark:'',
					aduit:'',
					ishanding:'',
					shShowBol:'',
					shKhadmin1Bol:''
				}
			}
		},
		mounted() {
			console.log(this.picList,222);
			this.moreEvent()
			this.getdata()
		},
		methods:{
			imgOpenClick(){
				this.openFlag = true
			},
			getdata(record = this.record){
			    let _this = this;
			    // if(!record.shShowBol){
			        let json = {
			            token : _this.$store.state.token,
			        }
			        https.fetchPost(apiUrl.getAdminRemarks,{
			            admintype: _this.forms.admintype,
			            token:json.token,
			            id:record.pdfcode,
			        },json).then((data) => {
			            if(Object.is(data.qmiscode,1000)){
							this.form.aduit = data.aduit;
			                this.form.ishanding = data.ishanding == '1' ? true : false;
			                this.form.shShowBol = true;
			                this.form.shKhadmin1Bol = (record.ishanding && _this.forms.admintype == 'khadmin1') && !(record.schedule == 1 && record.status == 1);
							console.log(this.form.shKhadmin1Bol,record)
						}else{
			                App.oTool.warningT(data.qmismsg);
			            }
			        }).catch(err => {
			            console.log(err);
			        });
			
			},
			shUnTgEvent(record) {
				if (!this.type_of_data && this.$store.state.rolesdata.indexOf('khadmin4') >= 0) {
						App.oTool.warningT('請選擇客戶資料或佣金資料');
						return
				}
				if (!this.form.remark) {
						App.oTool.warningT('請填寫備註信息');
						return
				}
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.KhAdminAduit, {
					admintype: _this.forms.admintype,
					typeofdata:_this.type_of_data,
					token: json.token,
					id: record.pdfcode,
					khid: record.pdfcode,
					status: '1',
					remark: this.form.remark
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						App.oTool.successT('操作成功');
						this.$emit('child', true);
					} else {
						if(Object.is(data.qmiscode, 4501)){
							App.oTool.warningT('證券帳號或身份信息重複');
						}else{
							App.oTool.warningT(res.data.qmismsg);
						}
					}
				}).catch(err => {
					console.log(err);
				});
			},
			// 添加客户信息接口
			// editQmisUserMsgFilePage(){
			// 	this.$ajax({
			// 		method: 'post',
			// 		url: this.$api.editQmisUserMsgFilePage,
			// 		data: {
			// 			username: '',
			// 			cn_name: '',
			// 			en_name: '',
			// 			nationcode: '',
			// 			phonenum: '',
			// 			email: '',
			// 			id_number: '',
			// 			bank: '',
			// 			bank_number: '',
			// 			address: '',
			// 			nationality_en: '',
			// 			address_en: '',
			// 			birth: '',
			// 			flag: '',
			// 		}
			// 	}).then(res => {
			// 		if (res.data.qmiscode === 1000) {
			// 			this.newUserFileAudit()
			// 		} else {
			// 			App.oTool.warningT(res.data.qmismsg);
			// 		}
			// 	})
			// },
			// HKIDR 审核接口
			// newUserFileAudit(){
			// 	this.$ajax({
			// 		method: 'post',
			// 		url: this.$api.newUserFileAudit,
			// 		data: {
			// 			status:'',
			// 			remark:'',
			// 			missionid:''
			// 		}
			// 	}).then(res => {
			// 		if (res.data.qmiscode === 1000) {
					

			// 		} else {
			// 			App.oTool.warningT(res.data.qmismsg);
			// 		}
			// 	})
			// },
			shTgEvent(record, type) {
				if (!this.form.remark) {
					if (type == 0) {
						if (this.form.shKhadmin1Bol) {
							this.form.remark = '已處理' 
						}else{
							if (this.$store.state.rolesdata.indexOf('khadmin1') >= 0) {
								this.form.remark = '客戶開戶資料齊全，審核通過。'
							}else if (this.$store.state.rolesdata.indexOf('khadmin2') >= 0) {
								this.form.remark = '客戶身份資料已核實，審核通過。'
							}else if (this.$store.state.rolesdata.indexOf('khadmin3') >= 0) {
								this.form.remark = '客戶開戶手續已完成，審核通過。'
							}else if (this.$store.state.rolesdata.indexOf('khadmin4') >= 0) {
								this.form.remark = '客戶已成功開戶，審核通過。'
							}else{
								this.form.remark = '審核通過'

							}
						}
					} else if (type) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}
				// 判断是手机端还是PC端 通过手机上传自拍照（pc端没有）逻辑判断
				// if (this.picList.length>0) {
				// 	// 手機
				// }else{
				// 	// PC

				// }
				// 取消返回直接接口
				if (type == 2 && false) {
					this.$confirm("客戶取消開戶後數據將會被清除", "是否取消開戶？", {
                        confirmButtonText: "確認",
                        cancelButtonText: "取消",
                        confirmButtonClass: "confirmbtn",//自定义class
                        type: "warning"
                    }).then(() => {
                        // confirmButton回调
                        this.$ajax({
                            method: "post",
                            // url: 'http://202.130.113.149:3785/admin/clearUserKhMsg',
                            url: this.$api.cancelAccountOpening,
                            data: {
								admintype: this.forms.admintype,
								token: this.$store.state.token,
								remark: this.form.remark,
								status:type,
								id:record.pdfcode,
								khid:record.pdfcode,
                            },
                        }).then((res) => {
                            if (res.data.qmiscode == 1000) {
                                this.$message.success('刪除成功')
								this.$emit('child', true);
                                // this.$router.go(0)
                            } else {
                                App.oTool.warningT(res.data.qmismsg);
                            }
                        });
                        next()
                    }).catch(() => {
                    })
					
				}else{
					this.$ajax({
						method: 'post',
						url: this.$api.KhAdminAduit,
						data: {
							admintype: this.forms.admintype,
							token: this.$store.state.token,
							remark: this.form.remark,
							status:type,
							id:record.pdfcode,
							khid:record.pdfcode,
						}
					}).then(res => {
						if (res.data.qmiscode === 1000) {
							App.oTool.successT();
							this.$emit('child', true);
							this.shShowBol = false;
	
						} else {
							if(Object.is(res.data.qmiscode, 4501)){
								App.oTool.warningT('證券帳號或身份信息重複');
							}else{
								App.oTool.warningT(res.data.qmismsg);
							}
						}
					})
				}

			},
			
			moreEvent(record=this.record){
			    let _this = this;
			    if(record.schedule == 4 && record.status == 0 && !record.aduit){
			        App.oTool.warningT("開戶審核已完成");
			        return;
			    }
			    if(record.status == 2){
			        App.oTool.warningT("開戶審核已取消");
			        return;
			    }
				if(record.websiteflag != 0 && record.finishflag ==1 &&_this.form.admintype =='khadmin1'){
				    App.oTool.warningT("沒有可用操作");
				    return;
				}
				
			    if(!record.moreShowBol){
			        let json = {
			            token : _this.$store.state.token,
			        }
			        https.fetchPost(_this.$api.getOpeningInfo,{
						aduitflag : 1,
			            id:record.pdfcode
			        },json).then((data) => {
			            if(Object.is(data.qmiscode,1000)){
							var otcTrading
							if (data.otcTrading == 0) {
								otcTrading = '未簽署'
							}else{
								otcTrading = '已簽署'

							}
			                this.moreFzOption = [
								{text:'證券帳號',value:data.khid},
			                    {text:'中文名稱',value:data.cn_name},
			                    {text:'英文名稱',value:data.en_name},
			                    {text:'國籍(中文)',value:data.nationality},
			                    {text:'國籍(英文)',value:data.nationality_en},
			                    {text:'電話號碼',value:data.phonenum},
								{text:'電郵地址',value:data.email},
			                    {text:'身份信息',value:data.id_number},
								{text:'銀行名稱',value:data.bank},
								{text:'銀行號碼',value:data.bank_number},
								{text:'通訊中文',value:data.address},
								{text:'通訊英文',value:data.address_en},
								{text:'居住國家',value:data.residential_nationality},
								{text:'場外交易',value:otcTrading},
			                ];
							this.params = data
			            }else{
			                App.oTool.warningT(data.qmismsg);
			            }
			        }).catch(err => {
			            console.log(err);
			        });
			    }else{
					//二级弹窗
					_this.visible_bold = false;
					//关闭一级弹窗
			        record.moreShowBol = false;
			    }
			},
		}
	}
</script>
<style>
	.yongjin_class .ant-input[disabled]{
		color: #000;
	}
	@media screen and (min-width:2200px){
		.ant-calendar-picker-input, .ant-input{
			font-size: 0.835rem;
		}
		.ant-input-affix-wrapper .ant-input-suffix{
			font-size: 0.835rem;

		}
	
	}
</style>

<style scoped>
	.back_close {
		cursor: pointer;
		position: absolute;
		top: 40px;
		right: 40px;
		width: 40px;
		height: 40px;
		font-size: 24px;
		color: #fff;
		background-color: #606266;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.back_view{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 99
	}
	.back_div{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.back_div_img{
		width: 1000px;
		height: 500px;
		background: #fff;
		display: flex;
		align-items: center;
    	justify-content: center;
	}
	.back_div_img img{
		max-width: 100%; 
		max-height: 100%;
	}

    .qianming_class{
		border-top: 1px solid #e5e5e5;
	}
	.look_g1{
		font-size: 0.95rem;
		color: #000000;
		position: relative;
		left: -14px;
	}
	
	.look_g1 .vertical_class{
		display: inline-block;
		width: 1px;
		height: 18px;
		position: relative;
		top: 0.1rem;
		margin-right: 0.5rem;
		border-left: 3px solid #0c8b97;
	}
	.yongjin_class{
		border-top: 1px solid #e5e5e5;
	}
	.yongjin_class .text{
		font-size: 0.835rem;
		color:#000;
		padding: 0.55rem 0;
		
	}
	.look_g{
		font-size: 0.95rem;
		color: #000000;
		position: relative;
		left: -14px;
	}
	.look_g div{
		display: inline-block;
		width: 1px;
		height: 18px;
		position: relative;
		top: 0.1rem;
		margin-right: 0.5rem;
		border-left: 3px solid #0c8b97;
	}
	#handitemedit  .tabelMoreFzView .tabelMoreFzViewIn {
	    background-color: #fff;
	    padding: 0.7rem 0;
	    border-radius: 4px;
		overflow: hidden;
	}
	
	#handitemedit  .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
	    padding: 0.5rem 0;
	    border-bottom: 1px #f3f3f3 solid;
	    display: flex;
	    align-items: center;
	}
	
	#handitemedit  .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
	    border: none;
	}
	
	#handitemedit  .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
	    width: 24%;
	    color: #000;
	    font-size: 0.835rem;
	}
	#handitemedit .center{
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}
	
	#handitemedit  .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
	    font-size: 0.835rem;
	    width: calc(70% - 2rem);
	    color: #000;
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		padding: 4px 11px;
		margin-left: 1%;
		height: 1.75rem;
		display: flex;
		align-items: center;
	}
	
	#handitemedit  .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
	    width: 1.2rem;
	    height: 1.2rem;
	    margin: auto 0;
	    margin-left: auto;
	}
	@media only screen and (max-width: 1024px) {
		.bjb_text1{
			width: 35% !important;
		}
		.bjb_win1{
			width: 16% !important ;
		}
		.bjb_win2{
			width: 34% !important;
			height: 30px !important;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: right;
		}
		#handitemedit .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center{
			height: 30px;
			width: 100%;
		}
		.tabelMoreFzViewInList{
			left: 0 !important;
		}
		#tubody-mainsk .warp_daochu{
			padding: 0.5rem;
		}
		.qx_bkb{
			padding-top: 0.85rem !important;
		}
	}
</style>
